<template>
    <div style="background: linear-gradient(to left, black, #202020); margin: 0; padding: 0;">
    <div class="page-wrapper">
        <BlogArticle/>
    </div>
        <div>
            <div style="justify-content: center; width: 100%">
                <div style="height: 3px; background: white; max-width: 800px;
                        margin: 20px auto 50px;">
                </div>
            </div>
            <div style="min-height: 30px; margin-top: 50px;">
                <p style="font-family: 'Mansalva', cursive; font-size: 26px; color: #FFD700;">technologies i use the most :</p>
            </div>
            <b-container class="bv-example-row" style="margin-top: 50px;">
                <b-row>
                    <b-col>
                        <img src="../assets/transparent_java.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_vue.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_spring.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <div style="min-height: 150px;"></div>
                    <div class="w-100"></div>
                    <b-col>
                        <img src="../assets/transparent_html.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_javascript.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_css.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <div style="min-height: 150px;"></div>
                    <div class="w-100"></div>
                    <b-col>
                        <img src="../assets/transparent_webstorm.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_gitlab.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                    <b-col>
                        <img src="../assets/transparent_intellij.png" alt="vue-logo" style="max-height: 90px; max-width: 90px;">
                    </b-col>
                </b-row>
            </b-container>
            <div style="min-height: 50px;"></div>
        </div>
        <div style="justify-content: center; width: 100%">
            <div style="height: 3px; background: white; max-width: 800px;
                        margin: 20px auto 50px;">
            </div>
        </div>
        <div class="page-scroll-up" style="display: inline-block; margin-bottom: 30px">
            <b-icon @click=this.scrollToTop id="icon" icon="arrow-up-circle-fill" style="width: 90px; height: 90px; color: #FFD700;"></b-icon>
            <p @click=this.scrollToTop>to the top</p>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>

    import Footer from "@/components/Footer";
    import BlogArticle from "@/components/BlogArticle";

    export default {
        name: 'BasePage',
        components: {Footer, BlogArticle},
        data() {
            return {
                blogArticleList: [
                    {
                        id: 1,
                        title: 'This is title 1',
                        subTitle: 'this is date 1',
                        imgSrc: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1352&q=80',
                        imgAlt: 'img alt1',
                        blogText: "If you don't succeed, dust yourself off and try again.",
                        blogLink: "localhost:8080/login",
                    },
                    {
                        id: 2,
                        title: 'This is title 2',
                        subTitle: 'this is date 2',
                        imgSrc: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1352&q=80',
                        imgAlt: 'img alt2',
                        blogText: "If you don't succeed, dust yourself off and try again. Take 2.",
                        blogLink: "localhost:8080/login",
                    },
                    {
                        id: 3,
                        title: 'This is title 3',
                        subTitle: 'this is date 3',
                        imgSrc: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1352&q=80',
                        imgAlt: 'img alt3',
                        blogText: "If you don't succeed, dust yourself off and try again. Take 3.",
                        blogLink: "localhost:8080/login",
                    }
                ]
            }
        },
        methods: {
            scrollToTop() {
                window.scrollTo(0, 0);
            },
        },
    }
</script>

<style scoped>

    .page-wrapper {
        width: 100%;
        height: auto;
        padding-top: 3px;
        margin-top: 50px;
        justify-content: center;
        background: linear-gradient(to left, black, #202020);
    }

    .page-scroll-up {
        width: 100%;
        height: 150px;
        background: linear-gradient(to left, black, #202020);
        position: relative;
    }

    #icon {
        position: relative!important;
        z-index: 20!important;
    }

    #p-pageend #text {
        max-height: 5px;
        width: 100%;
    }

    .page-scroll-up p {
        font-family: 'Mansalva', cursive;
        font-size: 40px;
        color: #FFD700;
        margin-top: -15px;
    }

    .bv-example-row {
        max-width: 800px;
    }


    @media only screen and (max-width: 370px) {
        .page-wrapper {
            margin-top: 35px;
        }

        .content {
            min-height: 200px;
        }
    }

    @media only screen and (min-width: 371px) and (max-width: 400px) {
        .page-wrapper {
            margin-top: -15px;
        }

        .content {
            min-height: 200px;
        }
    }


    @media only screen and (min-width: 401px) and (max-width: 600px) {
        .page-wrapper {
            margin-top: -70px;
        }

        .content {
            min-height: 200px;
        }
    }

    @media only screen and (min-width: 601px) and (max-width: 800px) {
        .page-wrapper {
            margin-top: -180px;
        }

        .content {
            min-height: 200px;
        }
    }

    @media only screen and (min-width: 801px) and (max-width: 1100px) {
        .page-wrapper {
            margin-top: -340px;
        }

        .content {
            min-height: 200px;
        }
    }

    @media only screen and (min-width: 1400px) {
        .page-wrapper {
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 300px) and (max-width: 600px) {
        .page-wrapper {
            margin-top: 300px;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 601px) and (max-width: 1000px) {
        .page-wrapper {
            margin-top: 450px;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 1001px) and (max-width: 1150px) {
        .page-wrapper {
            margin-top: 180px;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 1151px) and (max-width: 1400px) {
        .page-wrapper {
            margin-top: 0;
        }
    }
</style>
